define( 'views/inputLimit',[], function() {
    var view = Marionette.ItemView.extend({
        tagName: 'nf-section',
        template: '#tmpl-nf-field-input-limit',

        initialize: function() {
        	this.listenTo( nfRadio.channel( 'field-' + this.model.get( 'id' ) ), 'keyup:field', this.updateCount );
        	// An input mask empties a half-filled field on blur and reports it only as a change.
        	this.listenTo( nfRadio.channel( 'field-' + this.model.get( 'id' ) ), 'change:field', this.updateCount );
        	this.count = this.model.get( 'input_limit' );
        	this.render();
        },

        updateCount: function( el, model ) {
            var value = jQuery( el ).val();
            /**
             * A masked input holds placeholder and literal characters (e.g. "12_____"),
             * so count only what the user typed, as reported by the mask plugin.
             * The plugin's raw value goes stale when it empties the field on blur,
             * so an empty field is always counted as empty.
             **/
            var rawMaskFn = jQuery( el ).data( 'rawMaskFn' );
            if ( '' !== value && 'function' == typeof rawMaskFn ) {
                value = rawMaskFn();
            }
            var regex = /\s+/gi;
            var words = String(value).trim().replace(regex, ' ').split(' ');
            var wordCount = words.length;
            var charCount = value.length;
            
            /**
             * PHP Config has 'char' instead of 'characters', so I changed it to
             * 'characters', but added 'char' here so existing form fields will
             * act correctly
             **/
            if ( 'characters' == this.model.get( 'input_limit_type' )
                    || 'char' == this.model.get( 'input_limit_type' ) ) {
                jQuery( el ).attr( 'maxlength', this.model.get( 'input_limit' ) );
                this.count = this.model.get( 'input_limit' ) - charCount;
            } else {
                this.count = this.model.get( 'input_limit' ) - wordCount;
                var limit = this.model.get( 'input_limit' );
                if( wordCount > limit ){
                    /**
                     * Cut the original text where the first word past the limit starts,
                     * so the whitespace after the last allowed word and any line breaks
                     * survive; rejoining the words would let later letters glue on.
                     */
                    var wordRegex = /\S+/g;
                    var firstExtraWord;
                    for ( var i = 0; i <= limit; i++ ) {
                        firstExtraWord = wordRegex.exec( value );
                    }
                    // An empty field still counts as one word, so a limit of 0 finds no extra word to cut at.
                    jQuery( el ).val( value.slice( 0, firstExtraWord ? firstExtraWord.index : 0 ) );
                    this.count = 0;
                }
            }

        	this.render();
        },

        templateHelpers: function() {
        	var that = this;
        	return {
        		currentCount: function() {
        			return that.count;
        		}
        	}
        }

    });

    return view;
} );
